import React from 'react'

const InjuryCapture = ({ formData, setFormData, setCurrentStep }) => {
  const injuryTypes = ['Head', 'Torso', 'Legs', 'Arms', 'Feet', 'Hands', 'Cut', 'Burn', 'Possible break']

  const handleInjuryToggle = (injury) => {
    const newInjuries = formData.injuries.includes(injury)
      ? formData.injuries.filter((i) => i !== injury)
      : [...formData.injuries, injury]
    setFormData({ ...formData, injuries: newInjuries })
  }

  return (
    <div className='step-container'>
      <h2>Injury Details</h2>
      <p>Please select all areas affected by your injury</p>
      <div className='injuries-grid'>
        {injuryTypes.map((injury) => (
          <label key={injury} className='checkbox-item'>
            <input
              type='checkbox'
              checked={formData.injuries.includes(injury)}
              onChange={() => handleInjuryToggle(injury)}
            />
            <span>{injury}</span>
          </label>
        ))}
      </div>
      <button onClick={() => setCurrentStep(4)} className='btn-primary'>
        Continue
      </button>
    </div>
  )
}

export default InjuryCapture
